/**
 * 태블릿 앱 구매(스토어 이동)와 PC 앱 설치 파일 내려받기는 **다른 행동이다.**
 * PC 앱은 무료라 매출로 이어지지 않지만, 이 제품은 두 기기가 다 있어야 동작하므로
 * 어느 쪽이 먼저 끊기는지 보려면 따로 세어야 한다.
 */
export type EasyAirScreenRevenueEvent =
  | 'store_click_google_play'
  | 'store_click_app_store'
  | 'desktop_download_macos'

/**
 * 이벤트와 속성은 고정 경로로만 보낸다. body/cookie/사용자 식별자는 전송하지 않고,
 * 앞단 nginx 접근 로그의 시간·host·uri만 Loki에서 집계한다.
 */
export function revenueEventPath(event: EasyAirScreenRevenueEvent): string {
  switch (event) {
    case 'store_click_google_play':
      return '/_events/easy-air-screen/v1/store_click/google-play'
    case 'store_click_app_store':
      return '/_events/easy-air-screen/v1/store_click/app-store'
    case 'desktop_download_macos':
      return '/_events/easy-air-screen/v1/desktop_download/macos'
  }
}

export function sendRevenueEvent(event: EasyAirScreenRevenueEvent): boolean {
  if (typeof navigator === 'undefined' || typeof navigator.sendBeacon !== 'function') {
    return false
  }
  return navigator.sendBeacon(revenueEventPath(event))
}
